/* global window document */
/* eslint-disable */

import React from 'react';
import ReactDom from 'react-dom';
import thunk from 'redux-thunk';
import queryString from 'querystring';
// import logger from 'redux-logger';
import { getI18N } from '@3plearning/lingui-cdn';
import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';

import {
  handleDefaults
} from '../../helpers/utils';
import CombinedReducers from './combined-reducers';
import Resources from '../../helpers/resources';
import ProductService from '../../helpers/product-service';

export default class BasicApp {
  constructor(element, dynamicOptions) {
    BasicApp.configure();

    this.element = element;
    this.options = handleDefaults({}, dynamicOptions);

    this.renderElement();
  }

  render() {
    return (<h1 > You should define a render() method for your subclass of BasicApp </h1>);
  }


  // Implementation details.  You should not need to change any code past this point.

  renderElement() {
    const env = process.env.NODE_ENV || 'development';

    // Create the store with middlewares
    const middlewares = [
      thunk
    ];

    if (env === 'development') {
      // middlewares.push(logger);
      // eslint-disable-next-line global-require
      const whyDidYouUpdate = require('@welldone-software/why-did-you-render');
      whyDidYouUpdate(React);
    }

    const enhancers = [
      applyMiddleware(...middlewares)
    ];

    // If Redux DevTools Extension is installed use it, otherwise use Redux compose
    /* eslint-disable no-underscore-dangle */
    const composeEnhancers =
      process.env.NODE_ENV !== 'production' && typeof window === 'object' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
    /* eslint-enable */
    const initialState = ProductService.Configure();
    const store = createStore(
      CombinedReducers,
      initialState,
      composeEnhancers(...enhancers)
    );

    function linguiLocales() {
      const query = window.location.search.slice(1);
      const match = query.match(/\blocale=([-a-zA-Z]+)\b/);
      const locale = match ? match[1] : 'en-AU';

      return [locale];
    }

    const locales = linguiLocales();

    getI18N(window._env_.LocalisationCdnBaseUrl, locales)
      .then((i18n) => {
        ReactDom.render(
          this.render(store, i18n),
          document.querySelector(this.element)
        );
      });

    ReactDom.render(
      this.render(store),
      document.querySelector(this.element)
    );
  }

  static configure() {
    const location = window.location;
    const runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
    const queryParams = location.search;
    const query = queryParams.replace('?', '');
    const params = queryString.parse(query);

    BasicApp.configureForRemoteHost(params);    
  }

  static configureForRemoteHost(params) {
    const envName = 'live';
    const credentials = BasicApp.getCredentials(params);

    if (BasicApp.weHaveUsableCredentials(credentials)) {
      Resources.initialise(envName, credentials);
    }
  }

  static getCredentials(params) {
    const credentials = {};
    const items = ['authToken', 'username', 'password'];

    for (const paramName in params) {
      const value = params[paramName];

      for (const item of items) {
        if (paramName.toLowerCase() === item.toLowerCase()) {
          credentials[item] = value;
        }
      }
    }

    return credentials;
  }

  static weHaveUsableCredentials(credentials) {
    let usableCredentials = false;

    if (credentials.authToken) {
      usableCredentials = true;
    } else if (credentials.username && credentials.password) {
      usableCredentials = true;
    }

    if (!usableCredentials) {
      console.error('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' +
        ' a username/password pair.  After combining data from window.pppAppConfig and the query' +
        ' parameters, I still do not have what I need. The app will probably not function correctly if' +
        ' it requires any 3P resources.');
    }

    return usableCredentials;
  }
}
